import React from 'react'
import PropTypes from 'prop-types'
import { useParams } from 'react-router';
import PageContainer from '../../../layout/PageContainer'
import CreditLineDetail from './CreditLineDetail';


const CreditLineDetailContainer = ({ history, location: { state }, }) => {
  const { id } = useParams();
  return (
    <PageContainer
      breadcrumbs={[
        { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
        { id: 1, name: 'ASEGURADO', url: '/asegurado/polizas-credito' },
        { id: 2, name: 'LÍNEA CARTERA CLIENTES', url: '/asegurado/lineas-credito' },
        { id: 3, name: 'DETALLE' }
      ]}
      returnTo={state?.returnTo || "/asegurado/lineas-credito"} // Default fallback
      returnToFull
    >
      <CreditLineDetail id={id} history={history} />
    </PageContainer>
  );
}

CreditLineDetailContainer.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      returnTo: PropTypes.string,
    }),
  }).isRequired,
};

export default CreditLineDetailContainer;
